// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-C":"C_load-shedding-C__32Qel"};